import React from 'react';
import { MainLayoutSwitcher } from '../../../_layouts';
import { Composition } from '../../../types/api/Composition';
import { BreadcrumbSection } from '../../../_sections/Breadcrumb/BreadcrumbSection';

export const dataPrintModeMarker = { 'data-print-mode': 'true' };
export const dataPrintModeMarkerSelector = '[data-print-mode]';

export function PrintTemplate({ pages }: { pages: Composition[] }) {
  if (!pages || pages.length === 0) {
    return null;
  }

  return (
    <div className="print-tree" {...dataPrintModeMarker}>
      {pages.map((composition) => {
        const { sections, pageInfo, headMetaInfo, layout } = composition;
        return (
          <div key={headMetaInfo.id} className={pageInfo?.printable === true ? 'content' : 'content noprint'}>
            {sections.breadcrumb && <BreadcrumbSection {...sections.breadcrumb} />}
            <MainLayoutSwitcher layout={layout} contentSection={sections.content} contextSection={sections.context} />
          </div>
        );
      })}
    </div>
  );
}
